import { z } from "zod";
import { InvestmentPlanSchema } from "./InvestmentPlanSchema";

export const UserPurchasedPackSchema = z.object({
  id: z.string().uuid(),
  price: z.string(),
  createdAt: z.string().datetime(),
  investmentPlan: InvestmentPlanSchema,
});

export type UserPurchasedPackType = z.infer<typeof UserPurchasedPackSchema>;
